define('plugin/multiple-booking/model/MultipleBookingBatchModel',['require','lib/model/BaseModel','model/BookingServerRequestModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');
    var BookingServerRequestModel = require('model/BookingServerRequestModel');

    /**
     * Multiple booking batch model
     *
     * @class MultipleBookingBatchModel
     */
    return BaseModel.extend({

        url: '/booking/batch/',

        defaults: {
            id: null,
            token: '',
            type: '',
            is_closed: false,
            request_booking_model: null
        },

        toJSON: function () {
            var requestBooking = this.get('request_booking_model');
            if (requestBooking) {
                requestBooking.get('bookings').each(function (booking) {
                    booking.set('batch_model', null);
                });
            }
            return BaseModel.prototype.toJSON.apply(this, arguments);
        },

        parse: function (data, options) {
            if (data.request_booking_model) {
                var model = new BookingServerRequestModel();
                model.set(
                    model.parse(
                        data.request_booking_model
                    ), {silent: true}
                );

                data.request_booking_model = model;
            }

            return data;
        }

    });

});
